<template>
  <b class="required-marker">
    *
  </b>
</template>

<script>
export default {

}
</script>

<style scoped>
.required-marker {
    color: rgb(228,53,91)
}
</style>